import { render, staticRenderFns } from "./OtsClassesPage.vue?vue&type=template&id=69024f6a&"
import script from "./OtsClassesPage.vue?vue&type=script&lang=ts&"
export * from "./OtsClassesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69024f6a')) {
      api.createRecord('69024f6a', component.options)
    } else {
      api.reload('69024f6a', component.options)
    }
    module.hot.accept("./OtsClassesPage.vue?vue&type=template&id=69024f6a&", function () {
      api.rerender('69024f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/OtsClassesPage.vue"
export default component.exports